import React from 'react';
import { AlertTriangle } from 'lucide-react';

import { KeepBalanceNote } from './BudgetMoveConfirm';
import { BUDGET_CC_LABELS, inr, overheadShare } from '../../utilities/ccBudgetReturn';

/**
 * DCA budget amendment with a net reduction on a performing CC: on approval, net reduction x overhead % is taken
 * back from CC-12 (spApproveDCABudgetAmend). Shown on the amendment page and the amendment verification page.
 * Staging (spAmendDCABudget) and confirming (spAmendMultipleDCABudget) check CC-12's balance too, so the amendment
 * page passes its own failsWhen / then.
 */
const OverheadReturnNotice = ({ netReduction, overheadPercent, compact = false, failsWhen = 'the approval fails', then = 'approve' }) => {
    const share = overheadShare(netReduction, overheadPercent);
    if (!(share > 0)) return null;
    const body = (
        <>
            <p>
                Net reduction <span className="font-semibold">{inr(netReduction)}</span> x overhead {parseFloat(overheadPercent)}% ={' '}
                <span className="font-semibold text-rose-600 dark:text-rose-400">{inr(share)}</span> will be taken back from the budget of{' '}
                <span className="font-semibold">{BUDGET_CC_LABELS['CC-12']}</span> when this amendment is approved.
            </p>
            <KeepBalanceNote budgetCC="CC-12" amount={inr(share)} failsWhen={failsWhen} then={then} />
        </>
    );
    if (compact) return body;
    return (
        <div className="rounded-xl border border-amber-200 dark:border-amber-800/60 bg-white dark:bg-gray-800 p-4 space-y-3 text-sm text-gray-700 dark:text-gray-300">
            <div className="flex items-center gap-2 font-bold text-amber-700 dark:text-amber-400">
                <AlertTriangle className="h-4 w-4 flex-shrink-0" />
                This amendment takes overhead budget back from CC-12
            </div>
            {body}
        </div>
    );
};

export default OverheadReturnNotice;
